import { motion } from "framer-motion";
import { Database, MessageSquare, Share2, History, FileEdit } from "lucide-react";
import { FeatureCardHorizontal } from "@/components/ui/feature-card-horizontal";
import casosInterface from "@/assets/casos-interface.png";

const features = [
  {
    icon: <Database className="w-8 h-8 text-primary" />,
    title: "Base de Conhecimento",
    description: "Chega de perder tempo procurando documentos! IA organiza tudo automaticamente. Acesse qualquer informação do caso instantaneamente.",
  },
  {
    icon: <MessageSquare className="w-8 h-8 text-primary" />,
    title: "Chat Integrado com IA",
    description: "Converse com sua IA jurídica que conhece TODO o caso. Tire dúvidas, peça análises e gere documentos sem sair da conversa. Produtividade máxima.",
  },
  {
    icon: <Share2 className="w-8 h-8 text-primary" />,
    title: "Compartilhamento",
    description: "Compartilhe casos com sua equipe ou individualmente. Controle total de permissões. Colaboração em tempo real sem perder sigilo profissional.",
  },
  {
    icon: <History className="w-8 h-8 text-primary" />,
    title: "Histórico de Documentos",
    description: "Todas as petições e documentos ao seu alcance, edite, salve. Volte no tempo, compare mudanças. Zero preocupação com perdas.",
  },
  {
    icon: <FileEdit className="w-8 h-8 text-primary" />,
    title: "Editor de Documentos",
    description: "Editor profissional com formatação ABNT automática. Edite, exporte em PDF, imprima direto.",
  },
];

const containerVariants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.15,
    },
  },
};

const itemVariants = {
  hidden: { y: 20, opacity: 0 },
  visible: {
    y: 0,
    opacity: 1,
  },
};

const CasosFeatures = () => {
  return (
    <section id="casos-features" className="w-full py-20 px-4 bg-muted/30">
      <div className="max-w-7xl mx-auto">
        {/* Title Section */}
        <div className="text-center mb-16">
          <h2 className="text-5xl md:text-7xl font-bold mb-4 bg-gradient-to-r from-primary to-primary/60 bg-clip-text text-transparent">
            Tudo Aqui
          </h2>
          <p className="text-xl md:text-2xl text-muted-foreground">
            A IA conecta e você acelera
          </p>
        </div>

        {/* Two Column Layout: Image Left, Cards Right */}
        <div className="flex flex-col lg:flex-row gap-8 items-center">
          {/* Left Column: Image with macOS Frame */}
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
            className="w-full lg:w-1/2"
          >
            <div className="relative bg-gradient-to-br from-primary/20 via-primary/10 to-background rounded-lg p-1 shadow-2xl border border-primary/20">
              {/* macOS Header */}
              <div className="flex items-center gap-2 mb-1">
                <div className="w-3 h-3 rounded-full bg-red-500"></div>
                <div className="w-3 h-3 rounded-full bg-yellow-500"></div>
                <div className="w-3 h-3 rounded-full bg-green-500"></div>
              </div>

              {/* Image Container */}
              <div className="relative rounded-lg overflow-hidden bg-background/50 backdrop-blur-sm">
                <img
                  src={casosInterface}
                  alt="Interface do Sistema de Casos"
                  className="w-full h-auto rounded-lg"
                />
              </div>

              {/* Description below image */}
              <p className="text-center text-muted-foreground mt-6 text-sm md:text-base">
                A página Casos centraliza tudo que você precisa para gerenciar seus processos com máxima eficiência
              </p>
            </div>
          </motion.div>

          {/* Right Column: Feature Cards Stacked */}
          <motion.div
            className="w-full lg:w-1/2 flex flex-col gap-4"
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, margin: "-100px" }}
            variants={containerVariants}
          >
            {features.map((feature, index) => (
              <motion.div 
                key={index} 
                variants={itemVariants}
                transition={{ duration: 0.5 }}
              >
                <FeatureCardHorizontal
                  icon={feature.icon}
                  title={feature.title}
                  description={feature.description}
                />
              </motion.div>
            ))}
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default CasosFeatures;
